var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticClass:"box",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"boxTitle",staticStyle:{"margin":"15px"}},[_vm._v("国家贸易额")]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"30vh"},attrs:{"config":_vm.config1}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74641f88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/right/six.vue
// module id = null
// module chunks = 